module.exports = __webpack_public_path__ + "img/sbheader.159928fc.svg";